document.addEventListener('DOMContentLoaded', () => {
  const benefitElements = document.querySelectorAll('.benefit-text');
  benefitElements.forEach(el => {
    el.addEventListener('click', () => {
      let tag = el.textContent.trim().toLowerCase().replace(/\s+/g, '-'); 
      let newUrl = `/collections/all/${tag}`;
      window.location.href = newUrl;
    });
  });
  const benefitElement = document.querySelectorAll('.categories');
  benefitElement.forEach(el => {
    el.addEventListener('click', () => {
      let tag = el.textContent.trim().toLowerCase().replace(/\s+/g, '-'); 
      let newUrl = `/collections/all/${tag}`;
      window.location.href = newUrl;
    });
  });

var openBtn = document.querySelector("#custom--quiz");
var popup = document.getElementById("quizPopup");
var closeBtn = document.querySelector(".quiz-popup-close");

openBtn.addEventListener("click", function(e) {
  e.preventDefault();
  popup.style.display = "block";
});

var isClosed = localStorage.getItem("quizPopupClosed");

if (!isClosed && (window.location.pathname === "/collections" || window.location.pathname.includes("/products"))) {
  setTimeout(function() {
    popup.style.display = "block";
  }, 10000);
}

closeBtn.addEventListener("click", function() {
  popup.style.display = "none";
  localStorage.setItem("quizPopupClosed", "true");
});



  if (window.location.hash) {
    const id = window.location.hash.substring(1);

    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  }



});